import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { IndicatorCard } from "@/components/IndicatorCard";
import { IndicatorDetailDrawer } from "@/components/IndicatorDetailDrawer";
import { useGet } from "@/lib/api";

const GROUP_ORDER = ["labor", "inflation", "demand_growth", "pressures"];
const GROUP_LABELS = { labor: "Labor", inflation: "Inflation", demand_growth: "Growth", pressures: "Pressures" };

export function IndicatorsPage({ refreshKey, onDataChanged }) {
  const { data, loading } = useGet("/indicators", refreshKey);
  const [selected, setSelected] = useState(null);

  if (loading || !data) return <div className="text-center text-[#6B7280] py-20 font-mono-num">Loading indicators…</div>;

  const groups = {};
  data.groups.forEach((g) => (groups[g.key] = g.indicators));
  const available = GROUP_ORDER.filter((k) => groups[k]?.length);

  return (
    <div className="fade-up">
      <h1 className="font-display text-2xl font-bold mb-1">US Economic Indicators</h1>
      <p className="text-xs text-[#6B7280] mb-4 font-mono-num">{data.count} active signals · AU data hidden</p>

      <Tabs defaultValue={available[0]} className="w-full">
        <TabsList className="bg-[#111827] border border-white/10 w-full grid grid-cols-4 h-auto p-1 rounded-xl">
          {available.map((k) => (
            <TabsTrigger
              key={k}
              value={k}
              data-testid={`indicator-group-tab-${k}`}
              className="text-xs data-[state=active]:bg-[#F59E0B] data-[state=active]:text-black rounded-lg py-1.5"
            >
              {GROUP_LABELS[k]}
            </TabsTrigger>
          ))}
        </TabsList>

        {available.map((k) => (
          <TabsContent key={k} value={k} className="mt-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {groups[k].map((ind) => (
                <IndicatorCard key={ind.code} ind={ind} onClick={() => setSelected(ind.code)} />
              ))}
            </div>
          </TabsContent>
        ))}
      </Tabs>

      <IndicatorDetailDrawer
        code={selected}
        open={!!selected}
        onClose={() => setSelected(null)}
        onRecorded={onDataChanged}
      />
    </div>
  );
}
